<template>
  <div class="preview__container">
        <Preview :item="item"/>
  </div>
</template>

<script>
    // import Preview from '../v2/story-edit-view/newPreview.vue'
    import Preview from './AssetWebGlPreview.vue'
    import { mapState } from 'vuex'
    export default {
        components : { Preview },
        props : { 
            src : { type : String, default: null},
            item : { type : Object, default: null},
        },

        data(){
            return {
                selectedNodeType: "",
                selectedAnimation: 0,
                selectedFbxModel: 0,
                showShadow: true,  
                showSkeleton: false,
                allCharacters : [],
                selectedItem : null,
                currentDbNamed:{
                    "3d-model" : "prop",
                    "visual-effect" : "effect",
                    "character-model" : "character_model",
                    "character-animation" : "animation",
                    "voice" : "voice",
                    "sound" : "sound",
                    "video" : "video",
                    "images" : "overlay"
                },
            }
        },
        
        mounted(){
            this.$root.$on('playCurrentAsset', () => {
                this.addToWebGl()
            })
            if(window.unityInstance) this.reset(null)
            if(this.$store.state.characters && this.$store.state.characters.length > 0 ) this.$store.state.characters = [];
            if(this.item && this.item.id && window.unityInstance) this.changeSelectedModel(this.item.id,this.item)
        },
        computed: {
            ...mapState(['characters','unityInstanceReady']),
        },
        watch : {
            unityInstanceReady (state){
                if(state){
                        this.$store.state.characters = [];
                        this.changeSelectedModel(this.item.id,this.item);
                    }
            },
            'item.scale'(){this.updateModel(this.item)},
            'item.animation' : function(newAnimation, prevAnimation) {
                if(newAnimation && newAnimation.id && window.unityInstance){
                    this.reset('animation')
                    this.$root.$emit('controlPreview', { state: 'ReSet' })
                    if( prevAnimation && prevAnimation.id)window.unityInstance.SendMessage(this.item.objectId,"RemoveAnimationWithId", prevAnimation.id);
                    let jsonInfo =JSON.stringify({id: newAnimation.id, name: newAnimation.name, startTime: 0, endTime: 10});
                    window.unityInstance.SendMessage(this.item.objectId,"AddAnimationWithJson",jsonInfo);
                    this.$root.$emit('controlPreview', { state: 'Play' })
                }
            },
            'item.effect' : function(newEffect, prevEffect) {
                if(newEffect && newEffect.id && window.unityInstance){
                    this.reset('effect')
                    this.$root.$emit('controlPreview', { state: 'ReSet' })
                    let { id, name, prefabName, effectType} = newEffect
                    let jsonInfo =JSON.stringify({id: id, name: name, prefabName : prefabName, effectType : effectType, loop : true, parentObjectId :this.item.objectId ,startTime: 0, endTime: 8});
                    if(prevEffect && prevEffect.id)window.unityInstance.SendMessage(this.item.objectId,"RemoveEffectWithId", prevEffect.id);
                    window.unityInstance.SendMessage(this.item.objectId,"AddEffectWithJson",jsonInfo);
                    this.$root.$emit('controlPreview', { state: 'Play' })
                }
            },
            'item.voice' : function(newVoice, prevVoice) {
                if(newVoice && newVoice.id && window.unityInstance){
                    this.reset('voice')
                    let { voiceLanguage, voiceGender } = this.parseVoice(newVoice.description)
                    this.$root.$emit('controlPreview', { state: 'ReSet' })
                    let jsonInfo =JSON.stringify({id: newVoice.id, voiceGender : voiceGender, voiceEffect  : newVoice.name, voiceLanguage  : voiceLanguage, text : this.item.voice_text ,startTime: 0, endTime: 8});
                    if(prevVoice && prevVoice.id)window.unityInstance.SendMessage(this.item.objectId,"RemoveVoiceWithId", prevVoice.id);
                    window.unityInstance.SendMessage(this.item.objectId,"AddVoiceWithJson",jsonInfo); 
                    this.$root.$emit('controlPreview', { state: 'Play' })
                }
            },
            'item.id'(){
                window.unityInstance.SendMessage('AssetHandler','RemoveAssetWithId',this.item.objectId)
                this.$store.dispatch('updateCharacters', [])
                this.changeSelectedModel(this.item.id,this.item);
                setTimeout(() => {
                    this.addToWebGl()
                    
                }, 5000);
            }
        },
        methods : {
            addToWebGl(){
                let jsonInfo = {
                     animation : {id: null, name: null, startTime: 0, endTime: 10},
                     effect : {id: null, name: null, prefabName : null, effectType : null, loop : true, parentObjectId :this.item.objectId ,startTime: 0, endTime: 8},
                     voice : {id: null, voiceGender : null, voiceEffect  : null, voiceLanguage  : null, text : null ,startTime: 0, endTime: 8}
                }
                let currentAsset = this.currentDbNamed[this.$route.params.asset]
                if(currentAsset == 'voice') { 
                    this.item.voice = Object.assign(this.item.voice,this.parseVoice(this.item.voice.description))
                    this.item.voice.voiceEffect = this.item.voice.name
                    this.item.voice.text = this.item.text
                }
                jsonInfo[currentAsset] = Object.assign(jsonInfo[currentAsset],this.item[currentAsset])
                this.$root.$emit('controlPreview', { state: 'ReSet' })
                window.unityInstance.SendMessage(this.item.objectId,`Remove${this.toTitleCase(`${[currentAsset]}`)}WithId`, this.item[currentAsset].id);
                window.unityInstance.SendMessage(this.item.objectId,`Add${this.toTitleCase(`${[currentAsset]}`)}WithJson`,JSON.stringify(jsonInfo[currentAsset]));
                this.$root.$emit('controlPreview', { state: 'Play' })

            },
            toTitleCase(str) {
                return str.replace(
                    /\w\S*/g,
                    function(txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                    }
                );
            },
            reset(firedBy){
               if(firedBy != 'voice' && this.item.voice ) window.unityInstance.SendMessage(this.item.objectId,"RemoveVoiceWithId", this.item.voice.id);
               if(firedBy != 'effect' && this.item.effect ) window.unityInstance.SendMessage(this.item.objectId,"RemoveEffectWithId", this.item.effect.id);
               if(firedBy != 'animation' && this.item.animation ) window.unityInstance.SendMessage(this.item.objectId,"RemoveAnimationWithId", this.item.animation.id);

            },
            parseVoice(voiceDescription){
                let language =  voiceDescription.split(')')[0] + ')'
                let gender = voiceDescription.split(' ')[voiceDescription.split(' ').length-1]
                // return { language: language, gender: gender }
                return { voiceLanguage: language, voiceGender: gender }

            },
            changeSelectedModel (id, model) {
                this.allCharacters = this.characters.map((char) => ({ ...char, active: false }))
                let selectedOne = {
                    AndroidAssetBundle: model.asset_bundle.Android.fileURL,
                    bakedLighting: '',
                    characterElements: [],
                    dimensions: [1, 2, 1],
                    endTime: 10,
                    iOSAssetBundle: model.asset_bundle.iOS.fileURL,
                    interactiveSurface: '',
                    layer: 1,
                    material: '',
                    name: model.name,
                    objectDbHash: id,
                    objectId: Math.floor(Date.now() / 1000),
                    origin: {
                    position: [0.17, 0.1, -0.97],
                    rotation: [0, 181.50, 0]
                    },
                    polygonCount: 1,
                    presenceDuration: 10,
                    rigType: 'Humanoid',
                    scale: 1.40,
                    startTime: 0,
                    type: 'Character',
                    active: true
                }
                this.$store.dispatch('updateCharacters', [
                    ...this.allCharacters,
                    selectedOne
                ])
            },
            updateModel(model) {
                let newCharacters = [...this.characters]
                if(newCharacters[0])newCharacters[0].scale = parseFloat(model.scale)
                if (this.characters != newCharacters) {
                    this.$store.dispatch('updateCharacters', [])
                    this.$store.dispatch('updateCharacters', newCharacters)
                }
            }

        },
    }
</script>

<style lang="scss" scoped>
    .preview__container {
        width : 100%;
        height : 100%;
    }

</style>


// WEBPACK FOOTER //
// src/components/global/WebGlViewer.vue